var _defs, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilverpushLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-8 {\n        fill: none;\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m29.36,22.52c-.43,2.43,1.21,4.43,3.65,4.43s4.78-1.99,5.21-4.43c.43-2.43-1.21-4.43-3.65-4.43s-4.78,1.99-5.21,4.43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -252.93,
    y1: 454.28,
    x2: -252.46,
    y2: 454.28,
    gradientTransform: "translate(16929.2 30413.94) scale(66.9 -66.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50b29e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b8876"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m22.09,13.68c-.43,2.43,1.21,4.43,3.65,4.43s4.78-1.99,5.21-4.43c.43-2.43-1.21-4.43-3.65-4.43s-4.78,1.99-5.21,4.43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -252.93,
    y1: 454.41,
    x2: -252.46,
    y2: 454.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m19.01,31.38c-.43,2.43,1.21,4.43,3.65,4.43s4.78-1.99,5.21-4.43c.43-2.43-1.21-4.43-3.65-4.43s-4.78,1.99-5.21,4.43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 454.14,
    x2: -252.46,
    y2: 454.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m11.71,22.52c-.43,2.43,1.21,4.43,3.65,4.43s4.78-1.99,5.21-4.43c.43-2.43-1.21-4.43-3.65-4.43s-4.78,1.99-5.21,4.43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -252.93,
    x2: -252.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m14.83,4.81c-.43,2.43,1.21,4.43,3.65,4.43s4.78-1.99,5.21-4.43c.43-2.43-1.21-4.43-3.65-4.43s-4.78,1.99-5.21,4.43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -252.93,
    y1: 454.54,
    x2: -252.46,
    y2: 454.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m8.64,40.19c-.43,2.43,1.21,4.43,3.65,4.43s4.78-1.99,5.21-4.43c.43-2.43-1.21-4.43-3.65-4.43s-4.78,1.99-5.21,4.43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -252.93,
    y1: 454.01,
    x2: -252.46,
    y2: 454.01,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 28.93,
    y: 18.1,
    width: 9.71,
    height: 8.85
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.66,
    y: 9.26,
    width: 9.71,
    height: 8.85
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 18.58,
    y: 26.96,
    width: 9.71,
    height: 8.85
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 11.28,
    y: 18.1,
    width: 9.71,
    height: 8.85
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 14.4,
    y: 0.39,
    width: 9.71,
    height: 8.85
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.21,
    y: 35.76,
    width: 9.71,
    height: 8.85
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverpushLogo);
export default __webpack_public_path__ + "static/media/silverpush-logo.f842f3c8fcb1f582d0f949112b832452.svg";
export { ForwardRef as ReactComponent };